<template>
    <div class="scc-video-box">
        <div class="scc-video-box__left">
            <iframe class="scc-video-box__video" :src="videoSrc" autoplay> </iframe>
        </div>
        <div class="scc-video-box__right">
            <h2 class="scc-video-box__title">{{ title }}</h2>
            <p class="scc-video-box__text">{{ text }}</p>
            <SccLink class="scc-video-box__button" to="prijzen">
                {{ buttonText }}
            </SccLink>
        </div>
    </div>
</template>

<script>
import './video-box.scss';
import SccLink from './SccLink';

export default {
    name: 'VideoBox',
    __editor: {
        text: {
            widget: 'textarea',
        },
    },
    components: { SccLink },
    props: {
        videoSrc: {
            type: String,
        },
        title: {
            type: String,
            default: 'Prijzen',
        },
        text: {
            type: String,
            default: 'Bij de loterij kun je prijzen winnen die worden aangeboden door bedrijven.',
        },
        buttonText: {
            type: String,
            default: 'Bekijk alle prijzen',
        },
    },
};
</script>
